import { Component, OnInit,Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { ModalOptions } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-shape-file-modal',
  templateUrl: './shape-file-modal.component.html',
  styleUrls: ['./shape-file-modal.component.css']
})
export class ShapeFileModalComponent implements OnInit {

  @Input('UrlString') UrlString: string;
  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) {
    
  }

  get safeUrl(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.UrlString);
  }

  ngOnInit() {
    
  }

  close(): void {
    this.activeModal.close(false);
  }

}
